import { useTheme } from 'styled-components';
import { Test, TestContext } from '../../../2_domain/test/test';
import toIDString, {
  toIDStringWithHours,
} from '../../../lib/util/dateFormatter';
import { toIDPrice } from '../../../lib/util/numberFormatter';
import Column from '../../core/components/box/column';
import LXInformationCard from '../../core/components/box/lxInformationCard';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import { LXbody } from '../../core/texts/lxText';

interface InformationCardProps {
  test: Test;
}

const InformationCard: React.FC<InformationCardProps> = (props) => {
  const theme = useTheme();

  const getTotalPrice = () => {
    return (props.test.testItemList as any).testItem.reduce(
      (acc: any, cur: any) => acc + cur.amount,
      0
    );
  };

  const left = new Map<string, string>();
  const right = new Map<string, string>();

  const buildStatusRow = (color: string, space: number) => {
    return (
      <Row>
        <LXbody
          color={theme.colors.caption}
          width={'120px'}
          flexShrink={0}
          flexBasis={'120px'}
        >
          {theme.texts.status}
        </LXbody>
        <SizedBox width={20}></SizedBox>
        <Column>
          <LXbody
            flexGrow={1}
            flexShrink={1}
            flexBasis={'auto'}
            whiteSpace={'pre-line'}
            height={'auto'}
            overflowWrap={'break-word'}
            color={color}
            fontWeight={600}
          >
            {props.test.testStatus.label}
          </LXbody>
        </Column>
      </Row>
    );
  };

  const buildProperStatus = () => {
    if (props.test.testStatus.context === TestContext.READY) {
      return buildStatusRow(theme.colors.pinkBg, 0);
    } else if (props.test.testStatus.context === TestContext.DONE) {
      return buildStatusRow(theme.colors.title, 0);
    } else if (props.test.testStatus.context === TestContext.ABORT) {
      return buildStatusRow(theme.colors.caption, 0);
    } else if (props.test.testStatus.context === TestContext.ACTIVE) {
      return buildStatusRow(theme.colors.blueBg, 0);
    }
  };

  const makeProperRight = () => {
    if (props.test.canceledAt) {
      right.set(theme.texts.canceledDate, toIDString(props.test.canceledAt));
    }
    if (props.test.collectedAt) {
      right.set(
        theme.texts.canceledDate,
        toIDStringWithHours(props.test.collectedAt, true)
      );
    }
    if (props.test.expectedAt) {
      right.set(theme.texts.canceledDate, toIDString(props.test.expectedAt));
    }
    if (props.test.reportedAt) {
      right.set(theme.texts.canceledDate, toIDString(props.test.reportedAt));
    }
  };

  left.set(theme.texts.testDate, toIDString(props.test.createdAt));
  left.set(theme.staff.receptionist, `${props.test.registerClerk.name}`);
  left.set(theme.staff.attendingPhysician, `${props.test.personInCharge.name}`);
  left.set(theme.texts.totalPrice, toIDPrice(getTotalPrice(), true));
  left.set(theme.texts.memo, props.test.memo);

  makeProperRight();

  return (
    <LXInformationCard
      left={left}
      right={right}
      rightTop={buildProperStatus()}
    ></LXInformationCard>
  );
};

export default InformationCard;
